import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'identificador'
})
export class IdentificadorPipe implements PipeTransform {
  private readonly map: Record<number, string> = {
    1: 'CPF',
    2: 'CNPJ',
    3: 'Placa Cavalo',
    4: 'Placa Carreta'
  };

  transform(value: number | string | null | undefined): string {
    if (value === null || value === undefined || value === '') {
      return 'Não informado';
    }

    const key = Number(value); // ✅ converte "1" → 1

    return this.map[key] ?? 'Não informado';
  }
}
